import { Validator, Rules } from "vee-validate";
import ValidationUtil from "../entity/ValidationUtil";

export default {
  init() {
    // 電話番号の有効性チェック
    Validator.extend("custom_phoneNumber", {
      getMessage: () => "正しい電話番号を入力してください",
      validate: value => ValidationUtil.validateTel_jp(value),
    });

    // 未来日チェック
    Validator.extend("custom_isFutureDate", {
      getMessage: () => "未来日を入力してください",
      validate: value => ValidationUtil.isFutureDate(value),
    });

    // alpha_numの拡張: メッセージを変更
    // は英数字のみ使用できます -> は半角英数字のみ使用できます
    Validator.extend("half_size_alpha_num", {
      ...Rules.alpha_num,
      getMessage: n => `${n}は半角英数字のみ使用できます`,
    });
  },
};
